<template>
  <div class="editorCode">
    <client-only>
      <div ref="htmlContainer" v-html="data.code" />
    </client-only>
  </div>
</template>

<script>
export default {
  name: 'EditorCodeTool',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      scriptIds: [], // zapamiętane ID skryptów
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.executeScriptsWithHelper();
      }, 0);
    });

    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    this.cleanupScriptsWithHelper();
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      if (event.data.type === 'landingpage') {
        this.setIframeHeight(event.data);
      }
    },
    setIframeHeight(data) {
      const iframe = document.getElementById('landingpage');
      if (iframe) {
        iframe.style.height = `${data.height}px`;
      }
    },

    executeScriptsWithHelper() {
      const el = this.$refs.htmlContainer;
      if (!el) return;

      const scripts = el.querySelectorAll('script');
      const loadPromises = [];
      const inlineScripts = [];
      scripts.forEach((oldScript, index) => {
        const id = `injected-script-${Date.now()}-${index}`;
        const src = oldScript.getAttribute('src');
        if (src) {
          oldScript.remove();
          const loadPromise = this.$helper.loadScript(src, id);

          loadPromises.push(loadPromise);
          this.scriptIds.push(id);
        } else {
          inlineScripts.push({ id, content: oldScript.textContent });
          oldScript.remove();
        }
      });

      Promise.all(loadPromises).then(() => {
        inlineScripts.forEach(({ id, content }) => {
          const newScript = document.createElement('script');
          newScript.id = id;
          newScript.textContent = content;
          document.head.appendChild(newScript);
          this.scriptIds.push(id);
        });
      });
    },

    cleanupScriptsWithHelper() {
      this.scriptIds?.forEach(id => {
        this.$helper.removeScriptById(id);
      });
    },
  },
};
</script>

<style lang="scss">
.editorCode {
  iframe {
    display: block;
    max-width: 100%;
    width: 100%;
  }
}
</style>
